import { createContext, useContext } from 'react';
import type { AppTranslations } from 'translations/translations';

export const LocaleContext = createContext<AppTranslations | null>(null);

export function useLocale(): AppTranslations {
  const locale = useContext(LocaleContext);
  if (locale === null) {
    throw new Error('Trying to access locale out of LocaleContext provider');
  }
  return locale;
}
